import { Text } from "@mantine/core";
import { YearPickerInput } from "@mantine/dates";
import type { SubmitHandler } from "react-hook-form";
import { Controller, useForm } from "react-hook-form";
import { DeleteConfirmationModal } from "../../BuildingBlocks/Layout/Modals/DeleteConfirmationModal/DeleteConfirmationModal";
import { EARLIEST_YEAR } from "../../EnergyData/common";

interface YearSelectionForm {
  years: Array<string>;
}

interface DeleteMbksModalProps {
  isOpen: boolean;
  onToggleModal: () => void;
  onClickConfirm: (years?: ReadonlyArray<string>) => void;
}

function DeleteMbksModal({
  isOpen,
  onToggleModal,
  onClickConfirm
}: DeleteMbksModalProps) {
  const { control, handleSubmit } = useForm<YearSelectionForm>({
    defaultValues: { years: [] }
  });

  const handleValidSubmission: SubmitHandler<YearSelectionForm> = (data) => {
    const selectedYearsAsStrings = data.years.map((year) =>
      new Date(year).getFullYear().toString()
    );
    onClickConfirm(selectedYearsAsStrings);
  };

  return (
    <DeleteConfirmationModal
      modalBodyElement={
        <>
          <Text mb="xs">
            Klicken Sie auf Löschen, wenn Sie das Mess- und Bilanzierungskonzept
            löschen möchten. Es kann danach nicht wiederhergestellt werden. In
            Ihrem Dashboard können Sie ein neues MBK erstellen.
          </Text>
          <Text mb="xs">
            Falls nur für gewisse Jahre die MBKs gelöscht werden sollen, dann
            wählen Sie diese im Folgenden aus, bevor Sie unten auf &quot;Ja,
            löschen&quot; klicken. Bleibt die Jahresauswahl leer, werden alle
            vorhandenen MBKs gelöscht.
          </Text>
          <Controller
            control={control}
            name="years"
            render={({ field: { onChange, value } }) => (
              <YearPickerInput
                label="MBKs für folgende Jahre löschen"
                maxDate={new Date()}
                minDate={new Date(EARLIEST_YEAR, 0, 1)}
                placeholder="Jahre auswählen"
                popoverProps={{ withinPortal: false }}
                type="multiple"
                value={value}
                onChange={onChange}
              />
            )}
          />
        </>
      }
      name="Mess- und Bilanzierungskonzept"
      opened={isOpen}
      toggleModal={onToggleModal}
      onConfirm={handleSubmit(handleValidSubmission)}
    />
  );
}

export { DeleteMbksModal, DeleteMbksModalProps };
